<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Ítem de pedido</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              id="itemPedido"
              v-model="form.item"
              :options="items"
              @input="inputItem"
              @search="searchItems"
              label="nombre"
            ></v-select>
            <label for="itemPedido">Ítem*</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="cantidadPedido"
            v-model="form.cantidad"
            vMoney
            :format="decimal"
          >
            <span>Cantidad</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="cantidadPedido"
            v-model="form.precio"
            vMoney
            :format="money"
          >
            <span>Precio</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            readonly
            id="cantidadPedido"
            :value="total"
            vMoney
            :format="money"
          >
            <span>Total</span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="aceptar" class="btn-success">
        <i class="fa fa-check"></i><span>Aceptar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  computed: {
    total: function () {
      let cantidad = parseFloat(this.form.cantidad);
      let precio = parseFloat(this.form.precio);
      if (isNaN(cantidad)) cantidad = 0;
      if (isNaN(precio)) precio = 0;
      let total = round(cantidad * precio, precision);
      this.form.total = total;
      return total;
    },
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      decimal: decimal,
      money: money,
      moneyFormat: moneyFormat,
      items: [],
    };
  },
  methods: {
    searchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/items?search=" + search, true);
      xmlhttp.send();
    },
    inputItem: function () {
      if (this.form.item != null) {
        this.form.item_id = this.form.item.id;
        this.form.precio = this.form.item.precio;
      } else {
        this.form.item_id = "";
      }
    },
    aceptar: function () {
      if (this.form.item_id == "") {
        swal("Debe seleccionar un ítem.", "Aviso", "warning");
        return;
      } else {
        let cantidad = parseFloat(this.form.cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        if (cantidad == 0) {
          swal(
            "La cantidad es requerida y debe ser mayor a cero.",
            "Aviso",
            "warning"
          );
          return;
        } else this.$emit("input", this.form);
      }
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ItemPedido.vue